import Http from '../libs/http';

export default {
  // 获取活动详情
  getActivityInfo(params) {
    return Http.post('/sys/operating_activity_query', params);
    return new Promise((resolve, reject) => {
      const data = {
        id: 111,
        activity_type: 1,
        product_filter: 1,
        title: '活动名称',
        start_time: '2023-11-11 16:30:00',
        end_time: '2023-012-12 12:00:00',
        activity_floor: [
          {
            id: 1,
            floor_number: 1,
            floor_type: 1,
            pc_floor_image: 'https://o.666visa.cn/static/ssqpeer/activity/daily-activity/a.png',
            pc_jump_link: 'https://www.baidu.com/',
            pc_per_row_number: 1,
            background_color: '#3793FF',
          },
          {
            id: 8,
            floor_number: 1,
            floor_type: 3,
            pc_floor_image: 'https://o.666visa.cn/static/ssqpeer/activity/double-twelve/double-twelve-2.png',
            pc_jump_link: 'https://www.baidu.com/',
            pc_per_row_number: 1,
            background_color: '#3793FF',
          },
          {
            id: 9,
            floor_number: 1,
            floor_type: 3,
            pc_floor_image: 'https://o.666visa.cn/static/ssqpeer/activity/daily-activity/a.png',
            pc_jump_link: 'https://www.baidu.com/',
            pc_per_row_number: 3,
            background_color: '#3793FF',
          },
          {
            id: 1,
            floor_number: 1,
            floor_type: 2,
            pc_floor_image: 'https://o.666visa.cn/static/ssqpeer/activity/daily-activity/a.png',
            pc_jump_link: 'https://www.baidu.com/',
            pc_per_row_number: 1,
            background_color: '#3793FF',
          },
        ],
      };
      
      resolve(data);
    });
    
  },
  // 获取单个楼层的详细信息 商品
  getFloorProducInfo(params) {
    return Http.post('/sys/operating_activity_floor_product_query', params);

    return new Promise((resolve, reject) => {
      
      // floor_type 2 商品 3 优惠券
      const productData = {
        id: 1,
        total_count: 3,
        total_data: [
          {
            id: 1121,
            country: '国家名称',
            product_name: '商品名称',
            peer_price: 1100,
            special_price: 900,
            website_bkg_img: 'https://devo.666visa.cn/visa/visa_country_website_bkg_img_d56dc7bdf0a953114660f658660459b8.jpg',
          },
          {
            id: 1121,
            country: '国家名称',
            product_name: '商品名称',
            peer_price: 1100,
            special_price: 900,
            website_bkg_img: 'https://devo.666visa.cn/visa/visa_country_website_bkg_img_d56dc7bdf0a953114660f658660459b8.jpg',
          },
          {
            id: 1121,
            country: '国家名称',
            product_name: '商品名称',
            peer_price: 1100,
            special_price: 900,
            website_bkg_img: 'https://devo.666visa.cn/visa/visa_country_website_bkg_img_d56dc7bdf0a953114660f658660459b8.jpg',
          },
        ],
      };

      resolve(productData);
    });

  },
  // 获取单个楼层的详细信息 优惠券
  getFloorCouponInfo(params) {
    return Http.post('/sys/operating_activity_floor_coupon_query', params);

    return new Promise((resolve, reject) => {
      const couponData1 = {
        id: 1,
        start_time: '2023-12-01 11:00:00',
        end_time: '2023-12-05 18:00:00',
        receive_type: 1,
        total_count: 3,
        total_data: [
          {
            coupon_id: 1324,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [],
            status: 1,
            max_exchange: 1000,
            exchange_count: 10,
            scope: 0,
            reach_reduce: 0,
          },
          {
            coupon_id: 1324,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [],
            status: 1,
            max_exchange: 1000,
            exchange_count: 10,
            scope: 0,
            reach_reduce: 100,
          },
          {
            coupon_id: 132645,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [
              {
                visa_country_id: 35000,
                visa_country_name: '中国',
              },
            ],
            status: 0,
            max_exchange: 1000,
            exchange_count: 10,
            usage_count: 5,
            scope: 1,
            reach_reduce: 220,
          },
          {
            coupon_id: 132645,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [
              {
                visa_country_id: 35000,
                visa_country_name: '中国',
              },
            ],
            status: 0,
            max_exchange: 1000,
            exchange_count: 10,
            usage_count: 5,
            scope: 1,
            reach_reduce: 0,
          },
          {
            coupon_id: 132645,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [
              {
                visa_country_id: 35000,
                visa_country_name: '中国',
              },
              {
                visa_country_id: 35000,
                visa_country_name: '中国',
              },
            ],
            status: 0,
            max_exchange: 1000,
            exchange_count: 10,
            usage_count: 5,
            scope: 1,
            reach_reduce: 220,
          },
          {
            coupon_id: 132645,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [
              {
                visa_country_id: 35000,
                visa_country_name: '中国',
              },
              {
                visa_country_id: 35000,
                visa_country_name: '中国',
              },
            ],
            status: 0,
            max_exchange: 1000,
            exchange_count: 10,
            usage_count: 5,
            scope: 1,
            reach_reduce: 0,
          },
          {
            coupon_id: 132,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [],
            status: 0,
            max_exchange: 1000,
            exchange_count: 10,
            usage_count: 5,
            scope: 2,
            reach_reduce: 0,
          },
        ],
      };
      const couponData2 = {
        id: 1,
        start_time: '2023-11-12 11:00:00',
        end_time: '2023-12-29 18:00:00',
        receive_type: 2,
        total_count: 3,
        total_data: [
          {
            coupon_id: 1328,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [],
            status: 1,
            max_exchange: 1000,
            exchange_count: 100,
            scope: 0,
            reach_reduce: 1000,
          },
          {
            coupon_id: 13200,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [
              {
                visa_country_id: 35000,
                visa_country_name: '中国',
              },
            ],
            status: 2,
            max_exchange: 1000,
            exchange_count: 10,
            usage_count: 5,
            scope: 1,
            reach_reduce: 220,
          },
          {
            coupon_id: 1329,
            start_date: '2023-12-01 11:00:00',
            end_date: '2023-12-05 18:00:00',
            cash_reduce: 100,
            visa_country_set: [],
            status: 0,
            max_exchange: 1000,
            exchange_count: 10,
            usage_count: 5,
            scope: 0,
            reach_reduce: 0,
          },
        ],
      };
      console.log('优惠券楼层11111', params);
      resolve(couponData1);
      // if (params.id === 8) {
      //   resolve(couponData1);
      // } else {
      //   console.log('走这吗');
      //   resolve(couponData2);
      // }
    });

  },
  receiveCoupon(params) {
    return Http.post('/operating_coupon_excharge', params);

    return new Promise((resolve, reject) => {
      resolve('');
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/daily-activity-api.js